var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.333.333H13.19V13.19H.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.132c.656 0 1.19-.534 1.19-1.19 0-.656-.534-1.19-1.19-1.19-.656 0-1.19.534-1.19 1.19 0 .656.534 1.19 1.19 1.19zM9.381 9.25c0-.794-1.587-1.19-2.381-1.19-.794 0-2.381.396-2.381 1.19v.397h4.762v-.397zm1.323-7.01H3.296c-.582 0-1.058.475-1.058 1.057v7.408c0 .582.476 1.058 1.058 1.058h7.408c.582 0 1.058-.476 1.058-1.058V3.296c0-.582-.476-1.058-1.058-1.058zm0 8.465H3.296V3.296h7.408v7.408z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyUserWhite);
export default __webpack_public_path__ + "static/media/key_user_white.8a101ae37b5bcd4e20abdc7b1b04b3ab.svg";
export { ForwardRef as ReactComponent };